<!-- ETF头部行情 -->
<template>
  <div v-if="!this.$isEmpty(marketInfo)" class="etf-market-box">
    <!-- 第一行 -->
    <div class="line-one">
      <div v-for="(item, index) in marketList" :key="index" class="line-item">
        <!-- 第一项 -->
        <div v-if="!index" class="first-item">
          <div :style="{ color: getRateColor(item.rightRate)}" class="big-font"
            >{{item.price}}</div>
          <div class="row extra-price">
            <div :style="{ color: getRateColor(item.rightRate)}" class="mid-font"
              >{{item.leftRate}}</div>
            <div :style="{ color: getRateColor(item.rightRate)}" class="mid-font"
              >{{item.rightRate}}</div>
          </div>
        </div>
        <!-- 其余项 -->
        <div v-else>
          <div class="row" :style="{ marginTop: index >=3 ? '24px': 0}">
            <div class="desc">{{item.topLine.desc}}</div>
            <div class="small-font" :style="{ color: item.topLine.color || '#000000'}"
              >{{item.topLine.value}}</div>
          </div>
          <div class="row">
            <div class="desc">{{item.bottomLine.desc}}</div>
            <div class="small-font" :style="{ color: item.bottomLine.color || '#000000'}"
              >{{item.bottomLine.value}}</div>
            <img
              v-if="item.bottomLine.desc==='折价率'"
              src="https://j5.dfcfw.com/sc/image/202110/20211009012345.png"
              class="desc-tip-icon"
              @click="() => { modalType = 'zjl' }"/>
          </div>
        </div>
      </div>
    </div>
    <!-- 提示弹窗 -->
    <legend-tip-modal
      :modal-type="modalType"
      :detail-info="{}"
      @clickCancel="() => { modalType = '' }"
      />
  </div>
</template>

<script>
import LegendTipModal from '@/components/chart/LegendTipModal.vue';
import tool from '../../utils/tool';

export default {

  name: 'eft-market-header',

  components: {
    LegendTipModal,
  },

  props: {
    marketInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      modalType: '',
    };
  },

  computed: {
    marketList() {
      return [{ // 第一格与其他格样式不一样
        price: this.marketInfo?.price || '--',
        leftRate: this.marketInfo?.priceChange || '--',
        rightRate: this.marketInfo?.priceRise || '--',
      }, {
        topLine: {
          desc: '今开',
          value: this.marketInfo.todayOpenPrice,
          color: this.getRateColor(this.marketInfo.todayOpenPrice),
        },
        bottomLine: {
          desc: '昨收',
          value: this.marketInfo?.yesterdayClosePrice,
          color: this.getRateColor(this.marketInfo.yesterdayClosePrice),
        },
      }, {
        topLine: {
          desc: '净值',
          value: this.marketInfo.netValue,
        },
        bottomLine: {
          desc: '折价率',
          value: this.marketInfo?.discountRate,
          color: this.getRateColor(this.marketInfo.discountRate),
        },
      }, {
        topLine: {
          desc: '最高',
          value: this.marketInfo.highestPrice,
          color: this.getRateColor(this.marketInfo.highestPrice),
        },
        bottomLine: {
          desc: '最低',
          value: this.marketInfo?.lowestPrice,
          color: this.$isEmpty(this.marketInfo.lowestPrice) ? '#000000' : '#12B412',
        },
      }, {
        topLine: {
          desc: '涨停价',
          value: this.marketInfo.limitUpPrice,
          color: this.getRateColor(this.marketInfo.limitUpPrice),
        },
        bottomLine: {
          desc: '跌停价',
          value: this.marketInfo?.limitDownPrice,
          color: '#12B412',
        },
      }, {
        topLine: {
          desc: '成交量',
          value: this.marketInfo.volume,
        },
        bottomLine: {
          desc: '成交额',
          value: this.marketInfo?.turnover,
        },
      }];
    },
  },

  methods: {
    getRateColor: tool.getRateColor,
  },
};
</script>

<style lang="less" scoped>
.etf-market-box {
  width: 100%;
  .line-one {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: left;
    flex-wrap: wrap;
    .line-item {
      width: 33%;
      font-family: DINAlternate-Bold;
      .row {
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
      }
      .extra-price {
        margin-top: 5px;
      }
      .big-font {
        font-size: 58px;
      }
      .mid-font {
        font-size: 30px;
        margin-right: 15px;
      }
      .small-font {
        font-size: 26px;
        white-space: nowrap;
      }
      .desc-tip-icon {
        width: 24px;
        height: 24px;
        margin-left: 4px;
      }
      .desc {
        font-size: 26px;
        color: #999999;
        margin-right: 4px;
        white-space: nowrap;
      }
    }
  }
}
</style>
